import { render, staticRenderFns } from "./NewKeywordResearch.vue?vue&type=template&id=777e6f01&"
import script from "./NewKeywordResearch.vue?vue&type=script&lang=js&"
export * from "./NewKeywordResearch.vue?vue&type=script&lang=js&"
import style0 from "./NewKeywordResearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports